import {Component, EventEmitter, OnInit, Output, Input, HostListener} from '@angular/core';
import {Influencer} from '../../../../../models/influencer';

@Component({
  selector: 'influencer-overview-detail-popup',
  templateUrl: './influencer-overview-detail-popup.component.html',
  styleUrls: ['./influencer-overview-detail-popup.component.scss']
})
export class InfluencerOverviewDetailPopupComponent implements OnInit  {

  @Input() isShow: boolean;
  @Input() post: Influencer;
  @Output()
  public closePopupCardHover: EventEmitter<any> = new EventEmitter<any>();
  public influencerGroupId: string;
  public id: number;

  constructor() {
  }
  ngOnInit() {
  }

  onClose() {
    this.closePopupCardHover.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/influencer-overview-tab/influencer-overview-detail-popup/influencer-overview-detail-popup.component.ts